import LIST_SESSION_LOGS from '../../graphql/sessions/listLogs.gql';
import CALLS_IN_PROGRESS from '../../graphql/sessions/inProgress.gql';
import GET_COMPOSITION_URL from '../../graphql/sessions/getCompositionUrl.gql'
import {apolloClient} from "../../plugins/apollo-client";

const listSessionLogs = (filters) =>
  apolloClient
    .query({
      query: LIST_SESSION_LOGS,
      variables: filters,
      fetchPolicy: 'no-cache'
    })
    .then(({data: {sessionLogs}}) => sessionLogs);

const listCallsInProgress = () =>
  apolloClient
    .query({
      query: CALLS_IN_PROGRESS,
      fetchPolicy: 'no-cache'
    })
    .then(({data: {calls}}) => calls);

const getCompositionUrl = (compositionSid) =>
  apolloClient
    .query({
      query: GET_COMPOSITION_URL,
      fetchPolicy: 'no-cache',
      variables: {
        compositionSid
      }
    })
    .then(({data: {media}}) => media);

export {
  listSessionLogs,
  listCallsInProgress,
  getCompositionUrl
}
